/**
 * @generated SignedSource<<11a9809ddb1e83bec57693c6f75f58d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MondayColumnsSelectorsQuery$variables = {
  boardId: string;
};
export type MondayColumnsSelectorsQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly monday: {
        readonly allColumns: ReadonlyArray<{
          readonly columnType: string;
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        }>;
      } | null;
    };
  };
};
export type MondayColumnsSelectorsQuery = {
  response: MondayColumnsSelectorsQuery$data;
  variables: MondayColumnsSelectorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "boardId",
      "variableName": "boardId"
    }
  ],
  "concreteType": "MondayColumnNode",
  "kind": "LinkedField",
  "name": "allColumns",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "columnType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MondayColumnsSelectorsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MondayUserNode",
                "kind": "LinkedField",
                "name": "monday",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MondayColumnsSelectorsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MondayUserNode",
                "kind": "LinkedField",
                "name": "monday",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "80620ae15c60e158e18061abaf15614a",
    "id": null,
    "metadata": {},
    "name": "MondayColumnsSelectorsQuery",
    "operationKind": "query",
    "text": "query MondayColumnsSelectorsQuery(\n  $boardId: String!\n) {\n  viewer {\n    integrations {\n      monday {\n        allColumns(boardId: $boardId) {\n          id\n          name\n          columnType\n          externalId\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "62178defa067a31b1efd0a973bec101d";

export default node;
